// extracted by mini-css-extract-plugin
export default {"bannerComponent":"gl-z","red":"hl-z","calloutlink":"il-z","headerTopBanner":"jl-z","bgcolorRed":"kl-z","headerTopCallout":"ll-z","searchBanner":"ml-z","hideMobile":"nl-z"};